import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Ellipse13.png'
import _imports_1 from '@/assets/Ellipse14.png'


const _withScopeId = n => (_pushScopeId("data-v-708f0a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "d-flex footer-mag" }
const _hoisted_3 = { style: {"margin-right":"15rem"} }
const _hoisted_4 = { style: {"margin-right":"8rem"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["xlink:href"]
const _hoisted_7 = { class: "footer-btm" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-icon d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://facebook.com/WithHalal",
    icon: "facebook",
    target: "_blank",
    title: ""
  }, " Facebook "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://linkedIn.com/company/WithHalal",
    icon: "facebook",
    target: "_blank",
    title: ""
  }, " Linkedin "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/WithHalal",
    icon: "facebook",
    target: "_blank",
    title: ""
  }, " Twitter ")
], -1))
const _hoisted_9 = { class: "footer-p" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer-p" }, " 2nd floor, Albarakah Plaza, Awolowo Junction, Bodija Ibadan ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer-p" }, " WithHalal is a non-interest financial company and privacy is key to us. We protect visitor data against loss and unauthorized access. We information security techniques to appropriately guard confidential client information from unauthorized access by internal and external users. Access to client information is limited to those employees who have a legitimate business need for that information. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer-p footer-p-1" }, " You may not, except with our express written permission, distribute or commercially exploit the content. Nor may you transmit it or store it in any other website or other form of electronic retrieval system. ", -1))
const _hoisted_13 = { class: "footer-copy footer-p w-100 text-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-eclipse-1 footer-eclipse" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-100 h-100",
    alt: "ellipse"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-eclipse-2 footer-eclipse" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-100 h-100",
    alt: "ellipse"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.footerClass)
    }, [
      _createVNode(_component_logo, { class: "footer-logo" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list1, (list) => {
            return (_openBlock(), _createElementBlock("li", {
              key: list.name
            }, [
              _createVNode(_component_router_link, {
                to: list.link,
                class: "text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(list.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (list) => {
            return (_openBlock(), _createElementBlock("li", {
              key: list.name
            }, [
              _createVNode(_component_router_link, {
                to: list.link,
                class: "text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(list.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list3, (list) => {
          return (_openBlock(), _createElementBlock("li", {
            key: list.name
          }, [
            (list.icon)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                  _createElementVNode("use", {
                    "xlink:href": `${require('@/assets/icons.svg')}#icon-${list.icon}`
                  }, null, 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: list.link,
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(list.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, "© " + _toDisplayString(new Date().getFullYear()) + " withhalal.com", 1),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("p", _hoisted_13, " © " + _toDisplayString(new Date().getFullYear()) + " Withhalal.com. All rights reserved. ", 1)
    ]),
    _hoisted_14,
    _hoisted_15
  ]))
}